import { communicationService, context, utils } from '@wikia/ad-engine';
import { BIDDERS_CALL_PER_GROUP } from '../../../communication/events/events-bidders';

const logGroup = 'bid-before-run';

export function bidBeforeRunIfNecessary(slotName: string, callback: () => void) {
	const bidBeforeRun = !!context.get(`slots.${slotName}.bidBeforeRun`);
	const bidGroup = context.get(`slots.${slotName}.bidGroup`);

	if (bidBeforeRun && bidGroup) {
		utils.logger(logGroup, `Bid before push ${slotName}`);

		communicationService.emit(BIDDERS_CALL_PER_GROUP, {
			group: bidGroup,
			callback: () => {
				callback();
			},
		});
	} else {
		callback();
	}
}
